import { render, staticRenderFns } from "./Queries.vue?vue&type=template&id=5bfdb1bb"
import script from "./Queries.vue?vue&type=script&lang=js"
export * from "./Queries.vue?vue&type=script&lang=js"
import style0 from "./Queries.vue?vue&type=style&index=0&id=5bfdb1bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports